import { Subject } from "rxjs";
import { MatomoAction, MatomoCategory, MatomoEvent } from "../../models/matomo.model";

const getTabEvent = (routeId: string): MatomoEvent | null => {
	let event: MatomoEvent | null = null;
	switch (routeId) {
		case "appointments":
			event = {
				category: MatomoCategory.APPOINTMENTS,
				action: MatomoAction.APPOINTMENTS_TAB,
			};
			break;
		case "messages":
			event = {
				category: MatomoCategory.MESSAGES,
				action: MatomoAction.MESSAGE_TAB,
			};
			break;
		case "track-health":
			event = {
				category: MatomoCategory.TRACK_HEALTH,
				action: MatomoAction.TRACK_HEALTH_TAB,
			};
			break;
		default:
			break;
	}
	return event;
};

const subject = new Subject<boolean>();

export const MatomoService = {
	getTabEvent,
	setLoginEvent: () => subject.next(true),
	getLoginEvent: () => subject.asObservable(),
};
